/* @flow */
import * as React from 'react';
import Modal from 'react-modal';
import { WithRouterProps } from 'react-router';

import Button from 'components/Button';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ConfirmDialog from 'components/ConfirmDialog';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph';
import SETTINGS_ROUTES from 'settings/constants/SettingsRouteConstants';

import { withRouter } from 'app/context/Router';

type Props = {
  chat: Chat,
  buttonClassName: string,
} & WithRouterProps;

type State = {
  showEmailRequiredModal: boolean,
};
class EmailChatHistoryButton extends React.Component<Props, State> {
  state: State = {
    showEmailRequiredModal: false,
  };

  emailTranscript = (): void => {
    if (!CurrentUser.hasEmail()) {
      this.toggleShowEmailRequiredModal();
      return;
    }

    ChatActions.emailTranscript(this.props.chat.id);
  };

  renderEmailChatHistory() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.showEmailRequiredModal}>
          <ConfirmDialog
            title="Add an email address to your account first"
            subtext="Transcripts are sent to your email. You can add an email address in your account settings."
            actionButtonText="Go to Settings"
            cancelButtonText="Cancel"
            onConfirm={() => this.props.router.push(SETTINGS_ROUTES.NOTIFICATIONS)}
            onCancel={this.toggleShowEmailRequiredModal}
            onRequestHide={this.toggleShowEmailRequiredModal}
          />
        </Modal>
        <Button
          className={this.props.buttonClassName}
          level="text"
          weight="semibold"
          onClick={this.emailTranscript}>
          <Glyph name="email-transcript" size="large" />
          <span>Email message history</span>
        </Button>
      </React.Fragment>
    );
  }

  toggleShowEmailRequiredModal = () => {
    this.setState({
      showEmailRequiredModal: !this.state.showEmailRequiredModal,
    });
  };

  render() {
    return <div>{this.renderEmailChatHistory()}</div>;
  }
}

export default withRouter(EmailChatHistoryButton);
